import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {Items} from "../../models/items";

@Injectable({ providedIn: 'root' })
export class LogService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getAllPaged(offset: number, limit: number, filters?: any[], sort?: any[]) {
        let filtersStr = '';

        if (filters && filters['objectReference']) {
            filtersStr += '&filters[objectReference]=' + filters['objectReference'];
        }

        if (filters && filters['referenceId']) {
            filtersStr += '&filters[referenceId]=' + filters['referenceId'];
        }

        if (sort && sort['sortDir'] && sort['sortCol']) {
            filtersStr += '&sortDir=' + sort['sortDir'] + '&sortCol=' + sort['sortCol'];
        }

        return this.http.get<Items>(`${environment.apiEndpoint}/v1/logs?offset=` + offset + '&limit=' + limit + filtersStr, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
